import { render, staticRenderFns } from "./gateSetting.vue?vue&type=template&id=52377862"
import script from "./gateSetting.vue?vue&type=script&lang=js"
export * from "./gateSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports